import { ReactNode } from 'react';
import { EmptyState as ErrorState } from 'ui/emptyState';
import { ErrorStatePageError } from 'ui/illustrations';
import { EmptyState } from './EmptyState';
import { EmptyStateWrapper } from './SimpleTable.styled';
import { TableSkeleton } from './TableSkeleton';
import { ZeroState } from './ZeroState';

type TableBodyProps = {
  children: ReactNode;
  currentRecordsLength: number;
  hasRecords: boolean;
  isError: boolean;
  isLoading: boolean;
  numColumns: number;
  numRows: number;
  pluralResourceName: string;
};

/**
 * Table Body
 * Used to provide view for error, loading, empty, and zero states
 * Passes through children in absence of other state(s)
 */
export const TableBody = ({
  children,
  currentRecordsLength,
  hasRecords,
  isError,
  isLoading,
  numColumns,
  numRows,
  pluralResourceName,
}: TableBodyProps) => {
  if (isLoading) {
    return <TableSkeleton numRows={numRows} numColumns={numColumns} />;
  }

  if (isError) {
    return (
      <EmptyStateWrapper>
        <ErrorState
          Illustration={ErrorStatePageError}
          title="We’re having trouble getting this data right now."
          subtitle="Try refreshing the page, or reach out to our support team if the problem persists."
        />
      </EmptyStateWrapper>
    );
  }

  if (currentRecordsLength === 0 && !hasRecords) {
    return <EmptyState pluralResourceName={pluralResourceName} />;
  }

  if (currentRecordsLength === 0 && hasRecords) {
    return <ZeroState pluralResourceName={pluralResourceName} />;
  }

  return children;
};
